export default __webpack_public_path__ + "static/media/ivory.15aa3933.webp";